// TODO: Don't enable this until all modals are available for use in production
export const isModernResubscribeEnabled = () => false
